// extracted by mini-css-extract-plugin
module.exports = {"ChatTimeLess":"ChatTimeLess--nPEF+"};